import React from 'react';

export const BtnChiTietHopDong = ({ item, onOpenModalHopDong }) => {
    return (
        <a href="#!" onClick={() => onOpenModalHopDong(item)} className="blue btn-link">{item.MaHopDong}</a>
    );
};